import type { AuthType } from '@/integrations/Immersve/auth/AuthProvider';
import type { ThemePreference } from '@/common/Theme';

export const defaultConfig = {
  env: 'local',
  sentryDsn: '',
  sentryEnabled: false,
  apiBaseUrl: '',
  apiKey: '',
  apiSecret: '',
  authType: 'cookie' as AuthType,
  authClientIdTest: '',
  authClientIdLive: '',
  reviewerEmail: '',
  testModeEnabled: /^.*\.test\..*$/.test(window.location.hostname),
  axiosTimeout: 12000,
  theme: 'auto' as ThemePreference,
  localDates: false,
};

export const readOnlyConfigKeys: string[] = ['testModeEnabled'];

export type AppConfigSchema = typeof defaultConfig;
